export function getLiteralsPagePassenger(t: any) {
  return {
    title: t("literalsPassengers.title"),
    desc: t("literalsPassengers.desc"),
    requiered: t("literalsPassengers.required"),
    continueButton: t("literalsPassengers.continueButton"),
    back: t("literalsPassengers.back")
  }
}


export function getSecondaryTitleHolaBarcelona(data:any,t: any) {
  let result="";

  if(data.includes('48')){
    result=t("literalsHolaBarcelona.48")
  }else if(data.includes('72')){
    result=t("literalsHolaBarcelona.72")
  }
  else if(data.includes('96')){
    result=t("literalsHolaBarcelona.96")
  }
  else if(data.includes('120')){
    result=t("literalsHolaBarcelona.120")
  }
  else if(data.includes('24')){
    result=t("literalsHolaBarcelona.24")
  }
  return result
}

export function getTmbPassengersModal(t: any) {
  return {
    title: t("tmbPassengersModal.title"),
    description: t("tmbPassengersModal.description"),
    buttons:[ 
      {
        text: t("tmbPassengersModal.buttons.0.text")
      }
    ]
  }
}

export function getTmbPassengerSeniorModal(t: any) {
  return {
    title: t("tmbPassengersSeniorModal.title"),
    description: t("tmbPassengersSeniorModal.description"),
    buttons:[ 
      {
        text: t("tmbPassengersSeniorModal.buttons.0.text")
      }
    ]
  }
}



